<app-background backgroundImage="images/shared/backgrounds/background-3.avif">
    <h1 class="sr-only">SEM Nexus Team — Mobile App Developers and Growth Marketers</h1>
    <app-hero-section height="520px" paddingTop="300px" opacity=".8"
        [backgroundImage]="`images/${file}/backgrounds/${file}.avif`" [title]="`images/${file}/${file}.svg`"
        text="about us"></app-hero-section>
    <app-team-card-container></app-team-card-container>
    <app-connect></app-connect>
</app-background>